"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterTimetable = filterTimetable;
var getTimezonedDate_1 = require("./getTimezonedDate");
function filterTimetable(timezonedDate, timetable, timezone) {
    if (Array.isArray(timetable)) {
        return timetable.filter(function (rule) {
            if (rule.startDate &&
                timezonedDate.isBefore((0, getTimezonedDate_1.getTimezonedDate)(new Date(rule.startDate), timezone))) {
                return false; // Rule has not started yet
            }
            if (rule.endDate &&
                timezonedDate.isAfter((0, getTimezonedDate_1.getTimezonedDate)(new Date(rule.endDate), timezone))) {
                return false; // Rule has already ended
            }
            return true;
        });
    }
    return timetable || null;
}
//# sourceMappingURL=filterTimetable.js.map